---
pageId: faq
title: Najczęstsze pytania
description: Krótkie odpowiedzi o planach i limitach, trackerach, metrykach oraz Twoich danych w Samlli.
category: faq
order: 1
lang: pl
slug: faq
updated: 2026-08-06
---

Krótkie odpowiedzi na pytania, które słyszymy najczęściej. Każda odpowiedź prowadzi do strony, która wchodzi głębiej.

## Plany i limity

### Co obejmuje plan Free?

Pięć trackerów po maksymalnie 3 metryki, 2 kategorie, nowe wpisy bez limitu oraz 90 dni widocznej historii. Dostępny jest każdy widok Statystyk, także Rok. Wcześniejsze dni w układzie rocznym są zamaskowane i pozostają bezpiecznie zapisane.

### Co dodaje Pro?

Pro usuwa limity planu na trackery, metryki i kategorie oraz odblokowuje pełną historię. Sam widok roczny nie jest za paywallem; Pro odsłania historię zamaskowaną na Free.

### Czy szablony mieszczą się w planie Free?

Tak — każdy z 30 [szablonów](/pl/wiki/funkcje/szablony) celowo trzyma się maksymalnie 3 metryk, więc dowolny z nich działa na Free.

## Trackery i wpisy

### Czy mogę przełączyć tracker między trybem dziennika a trybem metryk?

Nie. Tryb wybierasz przy tworzeniu trackera i nie da się go później zmienić. Jeśli potrzebujesz drugiego trybu, utwórz nowy tracker — [Czym jest Tracker](/pl/wiki/koncepty/tracker) opisuje oba tryby.

### Co się dzieje po usunięciu trackera?

Usunięcie przenosi tracker do kosza, a trwałe usunięcie jest zaplanowane 30 dni później. Do tego czasu możesz go przywrócić z Ustawień. Archiwizacja to łagodniejsza opcja: tracker znika z głównej listy, ale zachowuje wszystkie dane bezterminowo.

### Czy mogę dodać wpis z przeszłego dnia?

Tak. Szuflada szybkiego dodawania ma przesunięcia jednym tapnięciem (-15m, -1h, -1d) i pełny wybór daty, a harmonogram trackera nigdy nie blokuje ręcznych wpisów z innych dni.

### Czy da się cofnąć usunięcie wpisu?

Nie — usunięcie wpisu prosi o potwierdzenie właśnie dlatego, że nie da się go cofnąć.

## Twoje dane

### Co się dzieje po downgrade do Free?

Nic nie jest usuwane. Istniejące trackery, metryki, kategorie i wpisy pozostają zapisane. Free pokazuje ostatnie 90 dni i blokuje jedynie tworzenie obiektów ponad limity planu. Powrót do Pro ponownie odsłania pełną historię.
